// MARK: React
import * as React from "react";
import { observer, inject } from "mobx-react";
import "./style.scss";

// MARK: Api
import { translateGastroPlaceType, allValuesGastroPlaceType } from "@startapp/mistral-admin-api";

// MARK: Components
import TextField from "../../../../components/TextField";
import ImageCase from "../../../../components/ImageCase";
import Button from "../../../../components/Button";
import Divider from "../../../../components/Divider";
import SelectOptions from "../../../../components/SelectOptions";

// MARK: Stores
import GastroPlaceStore from "../../../../stores/GastroPlaceStore";
import { routerStore } from "../../../../stores/_rootStore";

// MARK: Resources
import strings from "../../../../resources/strings";
import { match as Match } from "react-router";

interface IProps {
	gastroPlaceStore: GastroPlaceStore;
	match: Match<{ gastroPlaceId?: string }>;
}

@inject("gastroPlaceStore")
@observer
export default class GastroPlaceCreateOrEdit extends React.Component<IProps> {
	public componentDidMount = async () => {
		const gastroPlaceId = this.props.match.params.gastroPlaceId;
		if (gastroPlaceId) {
			await this.props.gastroPlaceStore.getGastroPlace(gastroPlaceId);
		}
	}

	public render() {
		const { gastroPlaceStore } = this.props;
		return (
			<div className="gastroPlaceCreateOrEdit">
				{!gastroPlaceStore.loading && (
					<div className="gastroPlaceCreateOrEditWrapper">
						<h1 className="gastroPlaceCreateOrEditTitle">{gastroPlaceStore.selectedGastroPlace ? strings.gastroPlaces.createOrEdit.title.edit : strings.gastroPlaces.createOrEdit.title.new}</h1>
						<div className="gastroPlaceFormContainer">
							<h2>{strings.gastroPlaces.createOrEdit.sections.data}</h2>
							<TextField
								label={strings.gastroPlaces.createOrEdit.fields.nick}
								name="nick"
								value={gastroPlaceStore.nick}
								onChange={gastroPlaceStore.handleValueChange}
								disabled={gastroPlaceStore.loading}
								required={true}
							/>
							<TextField
								label={strings.gastroPlaces.createOrEdit.fields.name}
								name="name"
								value={gastroPlaceStore.name}
								onChange={gastroPlaceStore.handleValueChange}
								disabled={gastroPlaceStore.loading}
								required={true}
							/>
							<TextField
								label={strings.gastroPlaces.createOrEdit.fields.description}
								name="description"
								multiline={true}
								value={gastroPlaceStore.description}
								onChange={gastroPlaceStore.handleValueChange}
								disabled={gastroPlaceStore.loading}
								required={true}
							/>
							<TextField
								label={strings.gastroPlaces.createOrEdit.fields.url}
								name="url"
								value={gastroPlaceStore.url}
								onChange={gastroPlaceStore.handleValueChange}
								disabled={gastroPlaceStore.loading}
							/>
							<SelectOptions
								title={strings.gastroPlaces.createOrEdit.fields.type}
								changeValue={gastroPlaceStore.toggleGastroPlaceTypes}
								values={allValuesGastroPlaceType()}
								selectedValue={gastroPlaceStore.selectedGastroPlaceType}
								translatorValue={translateGastroPlaceType}
							/>
						</div>
						<Divider className="divider" />
						<ImageCase
							title={strings.gastroPlaces.createOrEdit.fields.imageTitle}
							onAddItem={gastroPlaceStore.imageService.selectImages}
							onRemoveItem={gastroPlaceStore.imageService.removeImage}
							onReloadItem={gastroPlaceStore.imageService.reloadImage}
							imageUploaders={gastroPlaceStore.imageService.imageUploaders}
						/>
						<div className="buttonsContainer">
							<Button
								onClick={() => gastroPlaceStore.createOrEditGastroPlace()}
								style={{ backgroundColor: "#0081B0", color: "white" }}
							>
								{strings.gastroPlaces.createOrEdit.buttons.save}
							</Button>
							<Button
								onClick={() => routerStore.push("/dashboard/gastroPlaces")}
							>
								{strings.gastroPlaces.createOrEdit.buttons.back}
							</Button>
						</div>
					</div>
				)}
			</div>
		);
	}
}
